export default __webpack_public_path__ + "static/media/SMBC.b89c53f8.png";